import { Checkbox, Select, Spin } from "antd";
import { useCallback, useEffect, useState } from "react";
import debounce from "lodash/debounce";
import toast from "react-hot-toast";
import { createAdminNotification } from "../../../utils/notificationService";
import { BiPhoneCall, BiSolidFlag, BiSolidMessage } from "react-icons/bi";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Col, Label, Row } from "reactstrap";
import { getAllCustomers } from "../../../api/pagination.js";
import { statesArray } from "../../../data.js";
import {
  generateCustomID,
  saveData,
  uniqueID,
} from "../../../firebase/utility";
import GeneralButton from "../../button/GeneralButton.jsx";
import { CustomerDropdown } from "../../dropdown/DropDown.jsx";
import FormInput from "../../formInput/FormInput";
const SelectCustomer = ({ customer, setCustomer, toggle }) => {
  const history = useHistory();
  const { user } = useSelector((state) => state.auth);
  const [customers, setCustomers] = useState([]);
  const [sms_disabled, setSmsDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  //Billing States
  const [shippingAddress, setShippingAddress] = useState(true);
  const [address_1, setAddress_1] = useState("");
  const [address_2, setAddress_2] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [company, setCompany] = useState("");
  const [name, setName] = useState("");
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [country, setCountry] = useState("");
  //Shipping States
  const [shippingAddress_1, setShippingAddress_1] = useState("");
  const [shippingAddress_2, setShippingAddress_2] = useState("");
  const [shippingPhone, setShippingPhone] = useState("");
  const [shippingEmail, setShippingEmail] = useState("");
  const [shippingState, setShippingState] = useState("");
  const [shippingCity, setShippingCity] = useState("");
  const [shippingCompany, setShippingCompany] = useState("");
  const [customState, setCustomState] = useState("");
  const [customShippingState, setCustomShippingState] = useState("");
  const [shippingZipCode, setShippingZipCode] = useState("");
  const [shippingCountry, setShippingCountry] = useState("");
  const [quickBookId, setQuickBookId] = useState("");
  const [shippingFirstName, setShippingFirstName] = useState("");
  const [shippingLastName, setShippingLastName] = useState("");
  const [searchCustomers, setSearchCustomers] = useState([]);
  const [terms, setTerms] = useState("");
  const handleCustomer = (val) => {
    let data = searchCustomers?.length > 0 ? searchCustomers : customers;
    let res =
      data &&
      data?.find((i, index) => {
        return i?._id === val;
      });
    setCustomer(res);
  };
  useEffect(() => {

    if (customer?.billing) {
      const indexOneObj = customer?.billing[0];
      setTerms(indexOneObj?.terms);
      setAddress_1(indexOneObj?.address_1);
      setAddress_2(indexOneObj?.address_2);
      setPhone(indexOneObj?.phone);
      setEmail(indexOneObj?.email);
      setCity(indexOneObj?.city);
      setCompany(indexOneObj?.company);
      setState(indexOneObj?.state);
      setZipCode(indexOneObj?.postcode);
      setName(`${indexOneObj?.first_name} ${indexOneObj?.last_name}`);
      setCountry(`${indexOneObj?.country}`);
      setShippingAddress_1(indexOneObj?.address_1);
      setShippingAddress_2(indexOneObj?.address_2);
      setShippingPhone(indexOneObj?.phone);
      setShippingEmail(indexOneObj?.email);
      setShippingCity(indexOneObj?.city);
      setShippingCompany(indexOneObj?.company);
      setShippingState(indexOneObj?.state);
      setShippingZipCode(indexOneObj?.postcode);
      setShippingCountry(indexOneObj?.country);
      setFirstName(indexOneObj?.first_name);
      setLastName(indexOneObj?.last_name);
      setShippingFirstName(indexOneObj?.first_name);
      setShippingLastName(indexOneObj?.last_name);
      setQuickBookId(customer?.quickbooks_id);
    }
  }, [customer]);


  const collectCustomerData = async () => {
    setLoading(true);

    if (email === "" || phone === "") {
      toast.error("Please enter the details first!");
      setLoading(false);
      return;
    }

    try {
      const orderId = await generateCustomID("Orders", "id");
      if (!orderId) {
        toast.error("Failed to generate order ID");
        setLoading(false);
        return;
      }

      const userInfo = {
        username: user?.username ?? "",
        email: user?.email ?? "",
        role: user?.role ?? "",
        profileImage: user?.profileImage ?? "",
        phone: user?.phone ?? "",
        address: user?.address ?? "",
        _id: user?._id ?? "",
      };

      const finalShippingState =
        shippingAddress === true
          ? state === "Other"
            ? customState
            : state
          : shippingState === "Other"
            ? customShippingState
            : shippingState;

      const finalShippingZip =
        shippingAddress === true ? zipCode : shippingZipCode;

      const shippingCheckboxes = {
        sms_disabled: sms_disabled,
      };

      const customerDetails = {
        customer_id: quickBookId,

        billing: {
          first_name: first_name,
          last_name: last_name ?? "",
          company: company,
          address_1: address_1,
          address_2: address_2,
          city: city,
          state: state === "Other" ? customState : state,
          postcode: zipCode,
          country: country,
          email: email,
          phone: phone,
        },

        shipping: {
          first_name: shippingAddress === true ? first_name : shippingFirstName,
          last_name: shippingAddress === true ? last_name : shippingLastName,
          company: shippingAddress === true ? company : shippingCompany,
          address_1: shippingAddress === true ? address_1 : shippingAddress_1,
          address_2: shippingAddress === true ? address_2 : shippingAddress_2,
          city: shippingAddress === true ? city : shippingCity,
          state: finalShippingState,
          postcode: finalShippingZip,
          country: shippingAddress === true ? country : shippingCountry,
          email: shippingAddress === true ? email : shippingEmail,
          phone: shippingAddress === true ? phone : shippingPhone,
        },
        terms: terms ?? "",
        line_items: [],
        subTotal: 0,

        totalTaxAmount: {
          shippingAmount: 0,
          insurance: 0,
          discount: 0,
          tax: 0,
        },

        total: 0,
        id: orderId,
        _id: uniqueID(),
        status: "New",
        logs: [],
        date_created: Date.now(),
        shippingCheckboxes: shippingCheckboxes,
        createdBy: userInfo,
        allowedForUsers: user?._id ? [user._id] : [],
        taxExemptStates: customer?.taxExemptStates || [],
        paymentStatus: "Pending Payment",
      };

      if (!customerDetails.customer_id) {
        toast.error(
          "You can't create this order because QuickBooks ID is missing"
        );
        setLoading(false);
        return;
      }

      const res = await saveData(
        "Orders",
        customerDetails._id,
        customerDetails
      );

      if (res) {
        toast.success(`Sales Order #${customerDetails.id || orderId} created successfully!`);
        createAdminNotification({
          title: "Sales Order Created",
          message: `Sales Order #${customerDetails.id || orderId} was created by ${user?.username || "Admin"}`,
          category: "order",
          entityId: String(customerDetails.id || orderId),
          targetUrl: `/admin/sale-order-details/${customerDetails._id}`,
          actor: user,
        }).catch(console.error);

        setLoading(false);
        history.push({
          pathname: `/admin/sale-order-details/${customerDetails._id}`,
          state: customerDetails,
        });
      }
    } catch (error) {
      console.error("Create order error:", error);
      toast.error(
        "Something went wrong while creating order (tax or customer details)"
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!shippingAddress) {
      setShippingAddress_1("");
      setShippingAddress_2("");
      setShippingPhone("");
      setShippingEmail("");
      setShippingCity("");
      setShippingCompany("");
      setShippingState("");
      setShippingZipCode("");
      setShippingCountry("");
      setShippingFirstName("");
      setShippingLastName("");
    }
  }, [shippingAddress]);
  const fetchCustomersDebounced = useCallback(
    debounce((searchText) => {
      getAllCustomers(1, searchText, 50, "", (res) => {
        if (res) {
          setSearchCustomers(res?.data?.data);
          setCustomers(res?.data?.data);
        }
        setDataLoading(false);
      });
    }, 500),
    []
  );

  const handleCustomerSearch = (searchText) => {
    setDataLoading(true);
    fetchCustomersDebounced(searchText);
  };
  return (
    <>
      <Row className="mb-2">
        <Col md={6}>
          <label className="mb-2 fw-bold">Customer Name/Company</label>
          <Select
            size="large"
            showSearch
            loading={dataLoading}
            notFoundContent={
              dataLoading ? <Spin size="small" /> : "No vendors found"
            }
            placeholder={"Search Customer"}
            filterOption={false}
            onSelect={(val) => handleCustomer(val)}
            onSearch={(input) => handleCustomerSearch(input)}
            className="mb-2 w-100"
            getPopupContainer={(trigger) => trigger.parentNode}
            options={(searchCustomers?.length > 0
              ? searchCustomers
              : customers
            )?.map((option) => ({
              value: option._id,
              label: `${option.id} - ${option?.billing[0]?.company}`,
            }))}
          />
        </Col>
        <Col md={6}>
          <CustomerDropdown
            width={"100%"}
            label={"Customer Number"}
            placeholder={"Select"}
            object_key={"number"}
            options={customers}
            value={customer?.id ? Number(customer?.id) : "Customer Number"}
            showSearch={true}
            onSelect={(val) => {
              handleCustomer(val);
            }}
            height="45px"
            customClassName={"  w-100"}
          />
        </Col>
      </Row>
      <Row className="mb-1">
        <h4 className="primary-color">Billing Address</h4>
      </Row>
      <Row className="mb-2 bg-light p-3 rounded-3">
        <Col md={4}>
          <FormInput
            type={"text"}
            label={"Email"}
            placeholder={"Email"}
            value={email}
            handleChange={(e) => setEmail(e.target.value)}
            className={`  sales__inputCustomer }`}
            icon={<BiSolidMessage size={"20"} style={{ color: "#B0B0B0" }} />}
            readOnly={true}
          />
        </Col>
        <Col md={4}>
          <Label className="mb-1 fw-bold">Phone</Label>
          <div className="mb-3">
            <PhoneInput
              placeholder="Enter phone number"
              value={phone}
              style={{ width: "100%" }}
              onChange={setPhone}
              disabled={true}
            />
          </div>
        </Col>
        <Col md={4}>
          <FormInput
            type={"text"}
            label={"Company"}
            placeholder={"Company"}
            className={`  sales__inputCustomer }`}
            value={company}
            handleChange={(e) => setCompany(e.target.value)}
            icon={<BiPhoneCall size={"20"} style={{ color: "#B0B0B0" }} />}
            readOnly={true}
          />
        </Col>
        <Col md={6}>
          <FormInput
            type={"text"}
            label={"Address Line1"}
            placeholder={"Address_01"}
            className={`  sales__inputCustomer }`}
            value={address_1}
            handleChange={(e) => setAddress_1(e.target.value)}
            icon={<BiPhoneCall size={"20"} style={{ color: "#B0B0B0" }} />}
            readOnly={true}
          />
        </Col>
        <Col md={6}>
          <FormInput
            type={"text"}
            label={"Address Line2"}
            placeholder={"Address_02"}
            className={`  sales__inputCustomer }`}
            value={address_2}
            handleChange={(e) => setAddress_2(e.target.value)}
            icon={<BiPhoneCall size={"20"} style={{ color: "#B0B0B0" }} />}
            readOnly={true}
          />
        </Col>
        <Col md={3}>
          <FormInput
            type={"text"}
            label={"Country"}
            placeholder={"Enter Country Name"}
            className={` sales__inputCustomer }`}
            value={country}
            handleChange={(e) => setCountry(e.target.value)}
            readOnly={true}
          />
        </Col>
        <Col md={3}>
          <FormInput
            dropdown
            type={"select"}
            label={"State"}
            placeholder={"Enter State"}
            className={`border border-1 rounded-3 mb-3`}
            options={statesArray}
            showSearch={true}
            value={statesArray?.find((i) => i?.value === state)}
            handleChange={(value) => {
              setState(value);
            }}
            icon={<BiSolidFlag size={"20"} style={{ color: "#B0B0B0" }} />}
          />
        </Col>
        {state === "Other" && (
          <Col md={3}>
            <FormInput
              type={"text"}
              label={"Specify State"}
              placeholder={"State"}
              value={customState}
              handleChange={(e) => setCustomState(e.target.value)}
              className={`sales__inputCustomer`}
            />
          </Col>
        )}
        <Col md={3}>
          <FormInput
            type={"text"}
            label={"City"}
            placeholder={"Enter City Name"}
            className={` sales__inputCustomer }`}
            value={city}
            handleChange={(e) => setCity(e.target.value)}
            readOnly={true}
          />
        </Col>
        <Col md={3}>
          <FormInput
            type={"text"}
            label={"Zip Code"}
            placeholder={"Zip Code"}
            className={`  sales__inputCustomer }`}
            value={zipCode}
            handleChange={(e) => setZipCode(e.target.value)}
            icon={<BiPhoneCall size={"20"} style={{ color: "#B0B0B0" }} />}
            readOnly={true}
          />
        </Col>
      </Row>
      <hr />
      <Row className="mb-1">
        <h4 className="primary-color">Shipping Address</h4>
      </Row>
      <div className="mb-2">
        <Checkbox
          checked={shippingAddress}
          onChange={(e) => setShippingAddress(e.target.checked)}
        >
          Same as Billing Address
        </Checkbox>
      </div>
      {!shippingAddress && (
        <>
          <Row className="mb-2 bg-light p-3 rounded-3">
            <Col md={4}>
              <FormInput
                type={"text"}
                label={"First Name"}
                placeholder={"First Name"}
                value={shippingFirstName}
                handleChange={(e) => setShippingFirstName(e.target.value)}
                className={`sales__inputCustomer`}
                icon={
                  <BiSolidMessage size={"20"} style={{ color: "#B0B0B0" }} />
                }
              />
            </Col>
            <Col md={4}>
              <FormInput
                type={"text"}
                label={"Last Name"}
                placeholder={"Last Name"}
                value={shippingLastName}
                handleChange={(e) => setShippingLastName(e.target.value)}
                className={`sales__inputCustomer`}
                icon={
                  <BiSolidMessage size={"20"} style={{ color: "#B0B0B0" }} />
                }
              />
            </Col>
            <Col md={4}>
              <FormInput
                type={"text"}
                label={"Email"}
                placeholder={"Email"}
                value={shippingEmail}
                handleChange={(e) => setShippingEmail(e.target.value)}
                className={`  sales__inputCustomer }`}
                icon={
                  <BiSolidMessage size={"20"} style={{ color: "#B0B0B0" }} />
                }
              />
            </Col>
            <Col md={4}>
              <Label className="mb-1 fw-bold">Phone</Label>
              <div className="mb-3">
                <PhoneInput
                  placeholder="Enter phone number"
                  value={shippingPhone}
                  style={{ width: "100%" }}
                  onChange={setShippingPhone}
                />
              </div>
            </Col>
            <Col md={4}>
              <FormInput
                type={"text"}
                label={"Company"}
                placeholder={"Company"}
                className={`  sales__inputCustomer }`}
                value={shippingCompany}
                handleChange={(e) => setShippingCompany(e.target.value)}
                icon={<BiPhoneCall size={"20"} style={{ color: "#B0B0B0" }} />}
              />
            </Col>
            <Col md={6}>
              <FormInput
                type={"text"}
                label={"Address 01"}
                placeholder={"Address_01"}
                className={`  sales__inputCustomer }`}
                value={shippingAddress_1}
                handleChange={(e) => setShippingAddress_1(e.target.value)}
                icon={<BiPhoneCall size={"20"} style={{ color: "#B0B0B0" }} />}
              />
            </Col>
            <Col md={6}>
              <FormInput
                type={"text"}
                label={"Address 02"}
                placeholder={"Address_02"}
                className={`  sales__inputCustomer }`}
                value={shippingAddress_2}
                handleChange={(e) => setShippingAddress_2(e.target.value)}
                icon={<BiPhoneCall size={"20"} style={{ color: "#B0B0B0" }} />}
              />
            </Col>
            <Col md={3}>
              <FormInput
                type={"text"}
                label={"Country"}
                placeholder={"Enter Country Name"}
                className={` sales__inputCustomer }`}
                value={shippingCountry}
                handleChange={(e) => setShippingCountry(e.target.value)}
              />
            </Col>
            <Col md={3}>
              <FormInput
                dropdown
                type={"select"}
                label={"State"}
                placeholder={"Enter State"}
                className={`border border-1 rounded-3 mb-3`}
                options={statesArray}
                showSearch={true}
                value={statesArray?.find((i) => i?.value === shippingState)}
                handleChange={(value) => {
                  setShippingState(value);
                }}
                icon={<BiSolidFlag size={"20"} style={{ color: "#B0B0B0" }} />}
              />
            </Col>
            {shippingState === "Other" && (
              <Col md={3}>
                <FormInput
                  type={"text"}
                  label={"Specify State"}
                  placeholder={"Shipping State"}
                  value={customShippingState}
                  handleChange={(e) => setCustomShippingState(e.target.value)}
                  className={`sales__inputCustomer`}
                />
              </Col>
            )}
            <Col md={3}>
              <FormInput
                type={"text"}
                label={"City"}
                placeholder={"Enter City Name"}
                className={` sales__inputCustomer }`}
                value={shippingCity}
                handleChange={(e) => setShippingCity(e.target.value)}
              />
            </Col>
            <Col md={3}>
              <FormInput
                type={"text"}
                label={"Zip Code"}
                placeholder={"Zip Code"}
                className={`  sales__inputCustomer }`}
                value={shippingZipCode}
                handleChange={(e) => setShippingZipCode(e.target.value)}
                icon={<BiPhoneCall size={"20"} style={{ color: "#B0B0B0" }} />}
              />
            </Col>
          </Row>
        </>
      )}
      <Checkbox
        checked={sms_disabled}
        onChange={(e) => setSmsDisabled(e.target.checked)}
      >
        SMS Disabled
      </Checkbox>
      <div className="d-flex justify-content-end ">
        <GeneralButton
          title={"Cancel"}
          className={"white-button "}
          width={"200px"}
          height={"50px"}
          handleClick={toggle}
        />
        <p className="mx-2"></p>
        <GeneralButton
          title={"Create Order"}
          className={"blue-button "}
          width={"200px"}
          height={"50px"}
          handleClick={collectCustomerData}
          loading={loading}
          disabled={loading}
        />
      </div>
    </>
  );
};
export default SelectCustomer;
